import { FieldFactory, ParentFieldFactory, CreateFormContextOptions } from "../field-factory";
import { FormControl, FormBuilder } from "@angular/forms";
import { HiddenFormFieldSetting } from "./hidden-form-field-setting";
import { FormContext } from "../../form/form-context";
import { ViewRef } from "@angular/core";

export class HiddenFieldFactory implements FieldFactory<FormControl, HiddenFormFieldSetting<any>> {
  constructor(private parentFieldFactory: ParentFieldFactory, private formBuilder: FormBuilder) {}

  public create<M>({
    initialValue: value,
    formControl,
    setting,
    settings
  }: CreateFormContextOptions<M, FormControl, HiddenFormFieldSetting<M>>): FormContext<M, FormControl> {
    if (!formControl) {
      formControl = this.formBuilder.control(value);
      formControl.setValidators(setting.validators ? setting.validators : []);
      formControl.setAsyncValidators(setting.asyncValidators ? setting.asyncValidators : []);
    }

    return {
      initialValue: value,
      formControl,
      setting,
      settings,
      componentRef: null,
      children: []
    } as FormContext<M, FormControl>;
  }

  public render(): ViewRef {
    // hidden fields are not rendered
    return null;
  }

  public updateChildren() {}
}
